module.exports = __webpack_public_path__ + "static/media/Illya-1.c75cab50.jpg";